"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PlayerControlBoardProps = void 0;

var _vue = require("vue");

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _SelectDowmList = _interopRequireDefault(require("./component/SelectDowmList"));

var _playBar = _interopRequireDefault(require("./playBar"));

var _playScoreSetting = _interopRequireDefault(require("./playScoreSetting"));

var _playSetting = _interopRequireDefault(require("./playSetting"));

var _types = require("../types");

var playerControlBoardProps = {
  isCanPlay: {
    type: Boolean,
    default: true
  },
  isPlaying: {
    type: Boolean,
    default: false
  },
  playModes: Object,
  userDeviceOk: {
    type: Boolean,
    default: true
  },
  dragStartTime: {
    type: undefined || Number,
    default: undefined
  },
  isAreaSelectCanPlay: {
    type: Boolean,
    default: true
  },
  playMode: {
    type: String,
    default: 'ori'
  },
  canShowPlayScore: {
    type: Boolean,
    default: true
  },
  playParms: Object,
  playScoreParams: Object,
  playState: String,
  duration: Number,
  currentTime: Number,
  platform: {
    type: String
  },
  showGoCreation: {
    type: Boolean,
    default: false
  }
};
exports.PlayerControlBoardProps = playerControlBoardProps;
var PlayerControlBoard = (0, _vue.defineComponent)({
  name: 'PlayerControlBoard',
  components: {
    PlayBar: _playBar.default,
    PlaySetting: _playSetting.default,
    PlayScoreSetting: _playScoreSetting.default,
    SelectDownList: _SelectDowmList.default
  },
  props: playerControlBoardProps,
  emits: ['update:playState', 'update:playMode', 'update:playParms', 'update:dragStartTime', 'update:playScoreParams', 'goCreation'],
  setup: function setup(props, ctx) {
    var tempoPitchIng = (0, _vue.inject)('tempoPitchIng');
    var sheetMusicSongRef = (0, _vue.inject)('sheetMusicSongRef');
    var isPresetting = (0, _vue.inject)('isPresetting');
    var alertTipsNew = (0, _vue.inject)('alertTipsNew');
    var controlBoardRef = (0, _vue.ref)();
    var playSettingRef = (0, _vue.ref)();
    var playScoreSettingRef = (0, _vue.ref)();
    var playMode = (0, _vue.ref)(props.playMode);
    var isShowTips = (0, _vue.ref)(false);
    var userDeviceOk = (0, _vue.computed)(function () {
      return props.userDeviceOk;
    });
    var canShowPlayScore = (0, _vue.computed)(function () {
      return props.canShowPlayScore;
    });
    var playModes = (0, _vue.computed)(function () {
      return props.playModes;
    });
    var playModesPopoverStyle = (0, _vue.computed)(function () {
      var _a, _b;

      if ((_a = props.playModes) === null || _a === void 0 ? void 0 : _a.length) {
        return {
          width: '200px',
          minHeight: '141px',
          height: "".concat(((_b = props.playModes) === null || _b === void 0 ? void 0 : _b.length) * 42 + 15, "px")
        };
      } else {
        return {
          width: '200px',
          minHeight: '200px',
          height: '230px'
        };
      }
    });
    var playState = (0, _vue.ref)(props.playState);
    var dragStartTime = (0, _vue.ref)(props.dragStartTime);
    var playerOptions = (0, _vue.reactive)({
      seconds: undefined,
      curentSeconds: 0,
      drag: false,
      isFinish: false
    });
    var playParms = (0, _vue.reactive)(props.playParms);
    var playScoreParams = (0, _vue.reactive)(props.playScoreParams);
    var partInfos = (0, _vue.computed)(function () {
      return props.playParms.partInfo;
    });
    (0, _vue.watchEffect)(function () {
      playerOptions.curentSeconds = playMode.value === 'ori' || playMode.value === 'acc' || playMode.value === 'singAlong' ? (props.currentTime || 0) / 1000 : 0;
      playerOptions.seconds = (props.duration || 0) / 1000;

      if (props.currentTime === props.duration) {
        playerOptions.isFinish = true;
      } else {
        playerOptions.isFinish = false;
      }
    });
    (0, _vue.watch)(function () {
      return props.playMode;
    }, function (newVal) {
      playMode.value = newVal;
    });
    (0, _vue.watch)(function () {
      return props.playState;
    }, function (newVal) {
      playState.value = newVal; // 范唱、伴唱模式可拖动
      // 评分开启不可拖动
      // 只在播放后可拖动

      if (playScoreParams['score']) {
        playerOptions.drag = false;
      } else {
        if (playState.value === 'start' || playState.value === 'pause' || playState.value === 'continue') {
          if (playMode.value === 'ori' || playMode.value === 'acc') {
            playerOptions.drag = true;
          } else {
            playerOptions.drag = false;
          }
        } else {
          playerOptions.drag = false;
        }
      }
    });
    (0, _vue.watch)(function () {
      return props.playParms;
    }, function (newVal) {
      // console.log('playParms: prop playerControl ', newVal);
      (0, _extends2.default)(playParms, newVal);
    });
    (0, _vue.watch)(function () {
      return playMode.value;
    }, function (newVal) {
      ctx.emit('update:playMode', newVal);
    });
    (0, _vue.watch)(function () {
      return playState.value;
    }, function (newVal) {
      ctx.emit('update:playState', newVal);
    });
    (0, _vue.watch)(function () {
      return dragStartTime.value;
    }, function (newVal) {
      ctx.emit('update:dragStartTime', newVal);
    });
    (0, _vue.watch)(function () {
      return playScoreParams;
    }, function (newVal) {
      console.log('面板', newVal);
    }); // 显示playBar进度条拖动提示语

    var showPlayBarSlideTips = function showPlayBarSlideTips() {
      var content = '当前音频不可拖动';

      if (playScoreParams.score) {
        content = '评分状态下不可拖动进度条';
      } else if (playMode.value !== 'ori' && playMode.value !== 'acc') {
        content = '范唱、伴唱模式下才能拖动进度条';
      } else if (playState.value !== _types.PlayState.start && playState.value !== _types.PlayState.pause && playState.value !== _types.PlayState.continue) {
        content = '停止状态不可拖动进度条';
      }

      var hideMessage = alertTipsNew.showMessage('info', content);
      setTimeout(function () {
        hideMessage();
      }, 700);
    };

    (0, _vue.watch)(function () {
      return isShowTips.value;
    }, function (newVal) {
      if (newVal) {
        showPlayBarSlideTips();
        isShowTips.value = false;
      }
    });
    (0, _vue.watch)(function () {
      return playParms;
    }, function (newVal) {
      // console.log('playParms playerControl', newVal);
      ctx.emit('update:playParms', newVal);
    }, {
      deep: true
    });
    (0, _vue.watch)(function () {
      return playScoreParams;
    }, function (newVal) {
      ctx.emit('update:playScoreParams', newVal);
    }, {
      deep: true
    }); // 播放参数和评分项目有任何一个弹窗都打开蒙版

    var isNeedMask = (0, _vue.computed)(function () {
      var _a, _b;

      return ((_a = playSettingRef === null || playSettingRef === void 0 ? void 0 : playSettingRef.value) === null || _a === void 0 ? void 0 : _a.isShowToolTip) || ((_b = playScoreSettingRef === null || playScoreSettingRef === void 0 ? void 0 : playScoreSettingRef.value) === null || _b === void 0 ? void 0 : _b.showScore) || false;
    });

    var closeMask = function closeMask() {
      var _a;

      playSettingRef.value.showToolTip(false);
      playScoreSettingRef.value && ((_a = playScoreSettingRef.value) === null || _a === void 0 ? void 0 : _a.changeShowScore(false));
    };

    var openSheetMusic = function openSheetMusic() {
      var _a, _b;

      if (props.isPlaying) {
        return;
      }

      var jsBridge = window.WebViewJavascriptBridge;

      if (!jsBridge) {
        console.warn('[openSheetMusic] window.WebViewJavascriptBridge no found');
        return;
      }

      var songId = (_b = (_a = props === null || props === void 0 ? void 0 : props.playParms) === null || _a === void 0 ? void 0 : _a.song) === null || _b === void 0 ? void 0 : _b.id;

      if (!songId) {
        console.warn('[openSheetMusic] songId no found');
        return;
      }

      jsBridge && jsBridge.callHandler('openSheetMusic', {
        songId: songId
      });
    };

    var getPlayModePopupContainer = function getPlayModePopupContainer() {
      return controlBoardRef.value;
    };

    var isShowABTips = (0, _vue.ref)(false);

    var changeShowABTip = function changeShowABTip() {
      isShowABTips.value = !isShowABTips.value;
    };

    var pageClick = function pageClick(e) {
      if (e.target.className === 'AB-tips-icon' && !isShowABTips.value) {
        return;
      }

      var hasABTip = document.querySelector('.AB-tips-model');

      if (hasABTip) {
        isShowABTips.value = false;
      }
    };

    var clickPlayerControl = function clickPlayerControl(e) {
      if (isPresetting === null || isPresetting === void 0 ? void 0 : isPresetting.value) {
        console.log('正在进行预设参数,playControl 点击无效');
        e.stopPropagation();
      }
    };

    var onPlayBarBtnClick = function onPlayBarBtnClick(state) {
      if (state === 'start' || state == 'continue') {
        closeMask();
      }
    };

    var onGoCreation = function onGoCreation() {
      ctx.emit('goCreation');
    };

    (0, _vue.onMounted)(function () {
      document.addEventListener('mousedown', pageClick);
      document.addEventListener('touchstart', pageClick);
    });
    (0, _vue.onBeforeUnmount)(function () {
      document.removeEventListener('mousedown', pageClick);
      document.removeEventListener('touchstart', pageClick);
    });
    return {
      tempoPitchIng: tempoPitchIng,
      sheetMusicSongRef: sheetMusicSongRef,
      canShowPlayScore: canShowPlayScore,
      userDeviceOk: userDeviceOk,
      controlBoardRef: controlBoardRef,
      playSettingRef: playSettingRef,
      playScoreSettingRef: playScoreSettingRef,
      playMode: playMode,
      partInfos: partInfos,
      playModes: playModes,
      playModesPopoverStyle: playModesPopoverStyle,
      playState: playState,
      playParms: playParms,
      playerOptions: playerOptions,
      isShowABTips: isShowABTips,
      playScoreParams: playScoreParams,
      dragStartTime: dragStartTime,
      isShowTips: isShowTips,
      openSheetMusic: openSheetMusic,
      getPlayModePopupContainer: getPlayModePopupContainer,
      changeShowABTip: changeShowABTip,
      isNeedMask: isNeedMask,
      closeMask: closeMask,
      clickPlayerControl: clickPlayerControl,
      onPlayBarBtnClick: onPlayBarBtnClick,
      onGoCreation: onGoCreation
    };
  },
  render: function render() {
    var _this = this;

    return (0, _vue.createVNode)("div", {
      "class": "player-control-board",
      "ref": "controlBoardRef",
      "onClick": this.clickPlayerControl
    }, [this.isNeedMask && (0, _vue.createVNode)(_vue.Teleport, {
      "to": this.sheetMusicSongRef
    }, {
      default: function _default() {
        return [(0, _vue.createVNode)("div", {
          "class": "sheet-music-song-mask",
          "style": {
            display: _this.isNeedMask ? 'block' : 'none'
          },
          "onClick": function onClick() {
            return _this.closeMask();
          }
        }, null)];
      }
    }), (0, _vue.createVNode)("div", {
      "class": ['player-control', this.showGoCreation ? '' : 'player-control-65', this.platform !== 'android' && !this.canShowPlayScore || this.playMode === 'singAlong' ? 'player-control-win32' : '']
    }, [(0, _vue.createVNode)("div", {
      "class": "play-setting-container"
    }, [(0, _vue.createVNode)(_playSetting.default, {
      "playParms": _this.playParms,
      "onUpdate:playParms": function onUpdatePlayParms($event) {
        return _this.playParms = $event;
      },
      "playMode": this.playMode,
      "disabled": this.isPlaying || this.tempoPitchIng ? true : false,
      "platform": this.platform,
      "ref": "playSettingRef"
    }, null)]), (0, _vue.createVNode)("div", {
      "class": ['play-type-container', 'sheet-music-song-play-mode']
    }, [(0, _vue.createVNode)(_SelectDowmList.default, {
      "selectValue": _this.playMode,
      "onUpdate:selectValue": function onUpdateSelectValue($event) {
        return _this.playMode = $event;
      },
      "options": this.playModes,
      "popoverStyle": this.playModesPopoverStyle,
      "disabled": this.isPlaying || this.tempoPitchIng ? true : false
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "play-AB-part"
    }, [(0, _vue.createVNode)("div", {
      "class": [this.isPlaying || !this.isCanPlay || this.playMode === 'singAlong' ? 'AB-btn-none' : '', !this.isPlaying && this.playParms.closeAreaSelection ? 'AB-btn-active' : '', !this.isPlaying && !this.playParms.closeAreaSelection ? 'AB-btn' : ''],
      "onClick": function onClick() {
        if (_this.isPlaying || !_this.isCanPlay) {
          return;
        }

        _this.playParms.closeAreaSelection = !_this.playParms.closeAreaSelection;
      }
    }, null), (0, _vue.createVNode)("div", {
      "class": "AB-tips-icon",
      "onClick": this.changeShowABTip
    }, null), this.isShowABTips && (0, _vue.createVNode)("div", {
      "class": "AB-tips-model"
    }, [(0, _vue.createVNode)("div", null, [(0, _vue.createVNode)("div", null, [(0, _vue.createTextVNode)("1\u3001A\u70B9\u9009\u62E9\u6B4C\u8BCD\uFF0CB\u70B9\u53EA\u80FD\u9009\u62E9\u6B4C\u8BCD")]), (0, _vue.createVNode)("div", null, [(0, _vue.createTextVNode)("2\u3001A\u70B9\u9009\u62E9\u97F3\u7B26\uFF0CB\u70B9\u53EA\u80FD\u9009\u62E9\u97F3\u7B26")]), (0, _vue.createVNode)("div", null, [(0, _vue.createTextVNode)("3\u3001\u5728\u7B26\u54081\uFF0C2\u4E24\u70B9\u540E\u3002A\u70B9\u9009\u62E9\u5B8C\u6210\u540E\uFF0CB\u70B9\u7684\u9009\u62E9\u5FC5\u987B\u4FDD\u8BC1\u8BCD\u6216\u8005\u8C31\u80FD\u6210\u529F\u64AD\u653E")])])])]), (0, _vue.createVNode)("div", {
      "class": "play-bar-container"
    }, [(0, _vue.createVNode)(_playBar.default, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.playerOptions), {}, {
      "state": _this.playState,
      "onUpdate:state": function onUpdateState($event) {
        return _this.playState = $event;
      },
      "dragStartTime": _this.dragStartTime,
      "onUpdate:dragStartTime": function onUpdateDragStartTime($event) {
        return _this.dragStartTime = $event;
      },
      "isShowTips": _this.isShowTips,
      "onUpdate:isShowTips": function onUpdateIsShowTips($event) {
        return _this.isShowTips = $event;
      },
      "disabled": !this.isCanPlay || !this.isAreaSelectCanPlay,
      "onClick": this.onPlayBarBtnClick
    }), null)]), (0, _vue.createVNode)("div", {
      "class": ['play-score-container', this.platform !== 'android' && !this.canShowPlayScore || this.playMode === 'singAlong' ? 'play-score-container-win32' : '']
    }, [this.platform === 'android' ? (0, _vue.createVNode)("div", {
      "class": ['play-score-btn', this.isPlaying ? 'play-score-btn__disabled' : ''],
      "onClick": this.openSheetMusic
    }, [(0, _vue.createTextVNode)("\u8BC4\u5206")]) : '', this.playMode !== 'singAlong' && this.platform !== 'android' && this.canShowPlayScore && (0, _vue.createVNode)(_playScoreSetting.default, {
      "playScoreParams": _this.playScoreParams,
      "onUpdate:playScoreParams": function onUpdatePlayScoreParams($event) {
        return _this.playScoreParams = $event;
      },
      "partInfo": this.partInfos,
      "disabled": this.isPlaying || !this.userDeviceOk || !this.isCanPlay,
      "ref": "playScoreSettingRef"
    }, null)]), this.showGoCreation && (0, _vue.createVNode)("div", {
      "class": "go-creation",
      "onClick": this.onGoCreation
    }, [(0, _vue.createTextVNode)("\u521B\u7F16")])])]);
  }
});

PlayerControlBoard.install = function (app) {
  app.component(PlayerControlBoard.name, PlayerControlBoard);
  return app;
};

var _default2 = PlayerControlBoard;
exports.default = _default2;